import React, { useState } from 'react';
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBBtn,
  MDBInput
} from 'mdb-react-ui-kit';

function CompanyNameModal({ show, onClose, onSubmit, userName }) {
  const [companyName, setCompanyName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!companyName.trim()) {
      alert('⚠️ Please enter your company name');
      return;
    }

    setLoading(true);
    await onSubmit(companyName);
    setLoading(false);
  };

  return (
    <MDBModal open={show} tabIndex='-1' staticBackdrop>
      <MDBModalDialog centered>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Welcome, {userName}! 🎉</MDBModalTitle>
          </MDBModalHeader>

          <MDBModalBody>
            <p className="mb-3" style={{ color: '#666' }}>
              To get started, please tell us your company name:
            </p>
            
            <MDBInput
              label="Company Name"
              type="text"
              size="lg"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
              autoFocus
            />
          </MDBModalBody>

          <MDBModalFooter>
            <MDBBtn 
              color="primary" 
              onClick={handleSubmit}
              disabled={loading}
              style={{ width: '100%' }}
            >
              {loading ? 'Saving...' : 'Continue'}
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}

export default CompanyNameModal;